import React, { Component } from "react";
import arrowleft from "./img/Arrows_Left.png";
//component
import KeyResponsibilities from "views/know-us-more/components/KeyResponsibilities";
import RelationshipBanner from "views/know-us-more/components/RelationshipBanner";
import IndiaStory from "views/know-us-more/components/IndiaStory";

import JobVideoSlider from "views/know-us-more/components/JobVideoSlider";
import StoryView from "views/know-us-more/components/StoryView";
// import EmployeeCard from "views/know-us-more/components/EmployeeCard";
import SimlarJobs from "views/know-us-more/components/SimlarJobs";
import MoreJobs from "views/know-us-more/components/MoreJobs";
import Gallery from "views/know-us-more/components/Gallery";
import FooterSection from "views/home/components/FooterSection";
import "views/css/Index.scss";
import Token from "api/Auth/auth";
import store from "store.js";
import { setMgToken, setHcToken } from "store/Auth";
import { connect } from "react-redux";
import { getPreviewJobAction } from "store/SinglePortfolio";
import { requests } from "api/index";
import URLS from "api/endPoints";
import { getSingleJobAction, getRelatedJobs } from "store/SingleJob";
import { getRelatedPortfoliosByIDAction } from "store/Home";
import { withRouter } from "react-router-dom";
class JobDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      field: "",
      RealtedJobs: {},
      RelatedPortfolios: {},
    };
  }
  componentDidUpdate = async (prevProps) => {
    // console.log(prevProps)
    try {
  
    if (this.props.match.params.PID !== prevProps.match.params.PID) {

      // let HcToken = await Token.getToken();
      // store.dispatch(setHcToken(HcToken));
      let MgToken = await Token.getTokenMagitt();
      store.dispatch(setMgToken(MgToken));

      let responsePreviewJob = await this.props.getPreviewJobAction({
        id: this.props.match.params.PID,
      });
      if (responsePreviewJob) {
        // console.log(responsePreviewJob.p_featuredJob);
        let realtedjobs = await this.props.getRelatedJobs({
          JobIds: responsePreviewJob.p_featuredJob,
        });
        this.setState({ RealtedJobs: realtedjobs });
        let realtedPortfolios = await this.props.getRelatedPortfolios({
          RelatedPortfolioIDs: responsePreviewJob.p_relatedPortfolios,
        });
        // console.log(realtedPortfolios.Data)
        this.setState({ RelatedPortfolios: realtedPortfolios.Data });
        this.forceUpdate();
      }
    }
        
  } catch (error) {
      
  }
  };
  async componentDidMount() {
    // let HcToken = await Token.getToken();
    // store.dispatch(setHcToken(HcToken));
    try {
    
    let MgToken = await Token.getTokenMagitt();
    store.dispatch(setMgToken(MgToken));

    let responsePreviewJob = await this.props.getPreviewJobAction({
      id: this.props.match.params.PID,
    });
    // console.log(responsePreviewJob.Data.length>0)
    if(responsePreviewJob.Data.length>0){
    // console.log(responsePreviewJob.p_featuredJob);
    let realtedjobs = await this.props.getRelatedJobs({
      JobIds:responsePreviewJob.p_featuredJob
    })
    this.setState({RealtedJobs:realtedjobs})
    let realtedPortfolios = await this.props.getRelatedPortfolios({
      RelatedPortfolioIDs: responsePreviewJob.Data[0].p_relatedPortfolios
    })
    // console.log(realtedPortfolios.Data)
      this.setState({RelatedPortfolios:realtedPortfolios.Data})
  }else{
    this.props.history.push(
      process.env.PUBLIC_URL +"/Career/404-error"
     )
  }
  
} catch (error) {
  this.props.history.push(
    process.env.PUBLIC_URL +"/Career/404-error"
   )
}
  // RelatedPortfolioIDs
  }

  render() {
    return (
      <div className='mt-80px  lg:pt-8 md:pt-8'>
        <div className='lg:px-0 md:px-0 px-5'>
          <div className='mx-auto container'>
            <ul className='bradcrumb flex'>
              <li className='bradcrumb-li fsize14'>Home </li>&nbsp;/&nbsp;
              <li className='bradcrumb-li fsize14'> Know Us More</li>{" "}
              &nbsp;/&nbsp;
              <li className='text-black fsize14 font-semibold'>
                {this.props.previewjob
                  ? this.props.previewjob.p_title
                  : ""}
              </li>
            </ul>

            <div className='flex items-center mt-8'>
              <img src={arrowleft} alt='' />
              <h1 className='font-semibold fsize18 ml-2 text-black uppercase'>
                {this.props.previewjob 
                  ? this.props.previewjob.p_title
                  : ""}
              </h1>
            </div>
            <div className='bottom-b-grey mt-3'></div>
          </div>

          <div className='mx-auto container'>
            <RelationshipBanner />
          </div>
        </div>

        <div className='mx-auto container my-16'>
          {this.props.previewjob ? (
            <div
              className='content'
              dangerouslySetInnerHTML={{
                __html: decodeURIComponent(
                  this.props.previewjob.p_desciption
                ),
              }}
            ></div>
          ) : (
            ""
          )}{" "}
        </div>
        {/* <div className="mx-auto container my-16">
          <KeyResponsibilities />
        </div> */}
        {/* <div className="bg-f8f8f8 ">
          <IndiaStory />
        </div>
        <div className="mx-auto container my-16">
          <JobVideoSlider />
        </div> */}

        {/* <div className="mx-auto container my-16">
          <Gallery />
        </div> */}

        {/* <div className="bg-f8f8f8 lg:px-0 md:px-0 px-5">
          <StoryView />
        </div> */}

        {/* <div className="mx-auto container my-16">
        <EmployeeCard />
      </div> */}
        <div className='px-5 lg:px-0 md:px-0'>
          <div className=' container mx-auto'>
            <SimlarJobs id={this.props.match.params.PID} />
          </div>
        </div>
        <div className='px-5 lg:px-0 md:px-0'>
          <div className=' container mx-auto pb-12 pt-4'>
            <MoreJobs Jobs={this.state.RealtedJobs} />
            <div className='flex justify-center mt-12'>
              <button className='cust-viewall-btn flex'>VIEW ALL</button>
            </div>
          </div>
        </div>
        <div className='mt-6 footer-css'>
          <FooterSection />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    previewjob: state.SinglePortfolio.home.PREVIEWJOB.Data?state.SinglePortfolio.home.PREVIEWJOB.Data[0]:"",
    RelatedPortfolios: state.Home.home.GET_RELATED_PORTFOLIOS,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPreviewJobAction: async (payload) =>
      await dispatch(getPreviewJobAction(payload)),
    getRelatedJobs: async (payload) => await dispatch(getRelatedJobs(payload)),
    getRelatedPortfolios: async (payload) =>
      await dispatch(getRelatedPortfoliosByIDAction(payload)),
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobDetails));
